import { render, staticRenderFns } from "./QuestionGroup.vue?vue&type=template&id=2fe5187c&"
import script from "./QuestionGroup.vue?vue&type=script&lang=js&"
export * from "./QuestionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports